import script from "./wrap-with-hint.vue?vue&type=script&setup=true&lang=js"
export * from "./wrap-with-hint.vue?vue&type=script&setup=true&lang=js"

import "./wrap-with-hint.vue?vue&type=style&index=0&id=7bd33f9d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd33f9d"]])

export default __exports__